const LAYER_NAME_PROP = 'name';

const setLayerName = (layer, name) => {
    layer.set(LAYER_NAME_PROP, name);
};

const getLayer = (map, name) => {
    let layer = null;

    map.getLayers().forEach(l => {
        if (name === l.get(LAYER_NAME_PROP)) {
            layer = l;
        }
    });

    return layer;
};

const getLayerSource = (map, name) => {
    let layer = getLayer(map, name);
    return layer ? layer.getSource() : null;
};

export default {
    setLayerName,
    getLayer,
    getLayerSource,
};



// WEBPACK FOOTER //
// ./resources/assets/js/src/maps/layers.js